import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header';
import Home from './components/Home';
import Skills from './components/Skills';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Playlist from './components/Playlist';
import { Routes, Route } from "react-router-dom";
import { useEffect, useState, useCallback, useMemo } from 'react';
import Experience from './components/Experience';
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
import { AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import PageTransition from './components/PageTransition';

function AppRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransition><Home /></PageTransition>} />
        <Route path="/skills" element={<PageTransition><Skills /></PageTransition>} />
        <Route path="/experience" element={<PageTransition><Experience /></PageTransition>} />
        <Route path="/contact" element={<PageTransition><Contact /></PageTransition>} />
        <Route path="/playlist" element={<PageTransition><Playlist /></PageTransition>} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  const [viewers, setViewers] = useState(null);
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  useEffect(() => {
    const hasVisited = sessionStorage.getItem("hasVisited");

    if (!hasVisited) {
      fetch('https://areebahmedportfolio.vercel.app/')
        .then(response => response.json())
        .then(data => {
          setViewers(data.viewers);
          sessionStorage.setItem("hasVisited", "true");
        })
        .catch(error => console.error('Error fetching viewer count:', error));
    } else {
      fetch('https://areebahmedportfolio.vercel.app/api/get-count')
        .then(response => response.json())
        .then(data => setViewers(data.viewers))
        .catch(error => console.error('Error fetching viewer count:', error));
    }
  }, []);

  const particlesLoaded = (container) => {
    console.log(container);
  };

  const options = useMemo(
    () => ({
      background: {
        color: { value: "transparent" },
      },
      fpsLimit: 60,
      interactivity: {
        events: {
          onClick: { enable: true, mode: "push" },
          onHover: { enable: true, mode: "bubble" },
        },
        modes: {
          push: { quantity: 4 },
          bubble: { distance: 200, size: 6, duration: 2, opacity: 1 },
        }
      },
      particles: {
        color: { value: ["#ff007f", "#00e5ff", "#ffaa00"] },
        links: {
          enable: false,
        },
        move: {
          direction: "top",
          enable: true,
          outModes: { default: "out" },
          random: true,
          speed: 0.8,
          straight: false,
        },
        number: {
          density: { enable: true, width: 800, height: 800 },
          value: 60,
        },
        opacity: { 
          value: { min: 0.2, max: 0.8 },
          animation: { enable: true, speed: 1, minimumValue: 0.2 }
        },
        shape: { type: "circle" },
        size: { 
          value: { min: 2, max: 4 },
          animation: { enable: true, speed: 2, minimumValue: 1 }
        },
      },
      detectRetina: true,
    }),
    [],
  );

  return (
    <>
      <main className='background-animation'>
        {init && (
          <Particles
            id="tsparticles"
            particlesLoaded={particlesLoaded}
            options={options}
          />
        )}

        <Header />
        <AppRoutes />
        <Footer />
        <p style={{ color: 'var(--text-secondary)', fontSize: '12px', textAlign: 'center', margin: '20px 0', zIndex: 10, position: 'relative' }}>
          Current Viewer Count: {viewers !== null ? viewers : 'Loading...'}
        </p>
      </main>
    </>
  );
}

export default App;
